export function isNotNullNorUndefined(o: unknown): boolean {
    return o !== undefined && o !== null;
}

export function isNullOrUndefined(value: unknown): boolean {
    return value === null || value === undefined;
}
